import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nav", "trigger", "menu", "mobileMenu", "userMenu", "mobileSubmenu", "menuIcon", "closeIcon"]
  static values = {
    threshold: { type: Number, default: 100 }
  }

  connect() {
    this.closeDropdowns()
    document.addEventListener("click", this.clickOutside.bind(this))

    this.lastScrollTop = 0
    this.bindScrollEvent = this.handleScroll.bind(this)
    window.addEventListener('scroll', this.bindScrollEvent)

    // La classe 'fixed' est déjà ajoutée dans le HTML, donc nous n'avons pas besoin de l'ajouter ici
    this.navTarget.classList.add('transition-transform', 'duration-300')
  }

  disconnect() {
    document.removeEventListener("click", this.clickOutside.bind(this))
    window.removeEventListener('scroll', this.bindScrollEvent)
    this.enableScroll() // S'assurer que le scroll est réactivé lors de la déconnexion
  }

  handleScroll() {
    const st = window.scrollY || document.documentElement.scrollTop

    if (st > this.lastScrollTop && st > this.thresholdValue) {
      this.hideNavbar()
    } else if (st < this.lastScrollTop) {
      this.showNavbar()
    }

    this.lastScrollTop = st <= 0 ? 0 : st
  }

  hideNavbar() {
    this.navTarget.style.transform = "translateY(-100%)"
  }

  showNavbar() {
    this.navTarget.style.transform = "translateY(0)"
  }

  toggle(event) {
    event.preventDefault()
    const clickedMenu = event.currentTarget.nextElementSibling

    this.menuTargets.forEach(menu => {
      if (menu !== clickedMenu) {
        menu.classList.add("hidden")
      }
    })

    clickedMenu.classList.toggle("hidden")

    if (this.hasUserMenuTarget) {
      this.userMenuTarget.classList.add("hidden")
    }
  }

  toggleMobile() {
    this.mobileMenuTarget.classList.toggle("hidden")
    this.menuIconTarget.classList.toggle("hidden")
    this.closeIconTarget.classList.toggle("hidden")
    
    if (this.mobileMenuTarget.classList.contains("hidden")) {
      this.enableScroll()
    } else {
      this.disableScroll()
    }
  }

  disableScroll() {
    document.body.style.overflow = 'hidden'
    document.body.style.height = '100vh'
  }

  enableScroll() {
    document.body.style.overflow = ''
    document.body.style.height = ''
  }

  toggleMobileSubmenu(event) {
    const submenu = event.currentTarget.nextElementSibling
    submenu.classList.toggle("hidden")
  }

  toggleUser(event) {
    event.preventDefault()
    this.userMenuTarget.classList.toggle("hidden")

    this.menuTargets.forEach(menu => {
      menu.classList.add("hidden")
    })
  }

  closeDropdowns() {
    this.menuTargets.forEach(menu => menu.classList.add("hidden"))
    if (this.hasUserMenuTarget) {
      this.userMenuTarget.classList.add("hidden")
    }
    this.mobileSubmenuTargets.forEach(submenu => submenu.classList.add("hidden"))
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.closeDropdowns()
    }
  }
}
